var isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

var main = {

	initialize: function() {
		main.bindEvents();
		main.maquetat();
		main.browserDetect();
	},

	bindEvents: function() {
		//paso 1
		$('body').on('change', '.changeProvincia', main.changeProvincia);
		$('body').on('change', '.changePoblacion', main.changePoblacion);

		//paso 2-3-4-5
		$('body').on('click', '.clickEd', main.clickEd);
		$('body').on('click', '.selectTipo', main.maquetat);

		//paso 6
		$('body').on('change', '.selectTipo', main.selectTipo);

		$(document).ready(main.maquetat);
		$(document).ready(main.browserDetect);

		$(window).on('resize', main.maquetat);
		$('body').on('click','.togglePart', main.togglePart);
		$('body').on('click', '.amunt', main.scrollTop);
		$('body').on('click', '.soluciones_constructivas select', main.togglingInfo);
		
		$(window).scroll(main.scrollImg);
		$(window).load(main.loadReady);

	},

	changeProvincia: function() {
		value = $(this).val();

		if (value == -1) {
			$("[name='poblacion']").attr('disabled', 'disabled');
			$("[name='poblacion']").val(-1);
			$(".btn-send").attr('disabled', 'disabled');
			return false;
		}

		callData = {
			'value': value,
			'_token' : $('[name="_token"]').val()
		}

		$.post('/poblaciones', callData, function(data) {

			$('[name="_token"]').val(data.token);
			var options = $("[name='poblacion']");
			options.find('option').remove();
			options.append($("<option />").val(-1).text('Localidad'));

			$.each(data.results, function() {
				options.append($("<option />").val(this.id).text(this.poblacion));
			});

			$("[name='poblacion']").removeAttr('disabled');
			$(".btn-send").attr('disabled', 'disabled');
		});

	},
	changePoblacion: function() {
		value = $(this).val();

		if (value == -1) {
			$(".btn-send").attr('disabled', 'disabled');
		} else {
			$(".btn-send").removeAttr('disabled');
		}
	},

	clickEd: function() {
		value = $(this).attr('data-key');
		name = $(this).attr('data-name');

		$("[data-name='"+name+"']").removeClass('btn-success').addClass('btn-default');
		$(this).addClass('btn-success').removeClass('btn-default');

		$("[name='"+name+"']").val(value);

		$(".btn-send").removeAttr('disabled');
	},

	checkTripleCombo: function() {
		value = $("[name='fachada']").val();
		if (value == -1) {
			$(".btn-send").attr('disabled', 'disabled');
			return false;
		}
		value = $("[name='cubierta']").val();
		if (value == -1) {
			$(".btn-send").attr('disabled', 'disabled');
			return false;
		}
		value = $("[name='suelo']").val();
		if (value == -1) {
			$(".btn-send").attr('disabled', 'disabled');
			return false;
		}

		$(".btn-send").removeAttr('disabled');
	},

	selectTipo: function() {
		section = $("[name='section']").val();

		if (section != "obranueva") {
			main.checkTripleCombo();
		} else {
			fachada = $("[name='fachada']").val();
			cubierta = $("[name='cubierta']").val();
			suelo = $("[name='suelo']").val();

			//obtenemos cubiertas
			if ($(this).attr('name') == "fachada") {
				obtain_url = 'cubierta';
				str = "Tipo de cubierta";

				$("[name='cubierta']").val(-1).attr('disabled', 'disabled');
				$("[name='suelo']").val(-1).attr('disabled', 'disabled');
				$(".btn-send").attr('disabled', 'disabled');
			}
			if ($(this).attr('name') == "cubierta") {
				obtain_url = 'suelo';
				str = "Tipo de suelo";

				$("[name='suelo']").val(-1).attr('disabled', 'disabled');
				$(".btn-send").attr('disabled', 'disabled');
			}
			if ($(this).attr('name') == "suelo") {
				main.checkTripleCombo();

				return false;
			}

			var obj = {
				_token: $('[name="_token"]').val(),
				fachada: fachada,
				cubierta: cubierta,
				suelo: suelo
			}

			$.post('/obtain/' + obtain_url, obj, function(data) {
				$('[name="_token"]').val(data.token);
				var options = $("[name='"+obtain_url+"']");
				options.find('option').remove();
				options.append($("<option />").val(-1).text(str));

				$.each(data.values, function() {
					options.append($("<option />").val(this.id).text(this.item));
				});

				$("[name='"+obtain_url+"']").removeAttr('disabled');
			});

		}

	},

	//Arriba el moment del Flexboxing

	maquetat: function() {

		
		header = $('header');
		footer = $('footer');
		details = $('#details');
		section = $('section');
		submenu = $('#submenu');
		nav = $('nav');
		aside = $('aside');
		dins = $('.dins');
		mainT = $('main');
		optiondiv = $('.option div');

		Hwindow = $(window).height();
		Hh4 = $('main h4').outerHeight(true);
		Hsubmenu = submenu.outerHeight(false);
		Hdetails = details.outerHeight(false);
		Hfooter = footer.outerHeight(false);
		Hheader = header.height();
		Hsection = section.height();
		Hmain = mainT.height();
		Wnav = nav.width();
		Waside = aside.width();
		Hoptiondiv2 = (optiondiv.outerHeight(false)*0.5);

		Hfoot10 = Hfooter+10;
		Hheadfoot = Hheader+Hfooter;
		Hmainhf = Hmain+Hheadfoot+30;
		HNoMain = Hheadfoot+Hsubmenu;
		Hdetfoot = Hfooter+Hdetails;
		Hdetfoot150 = Hdetfoot+150;
		Hdinsresta = Hh4+Hheadfoot+15;
		Hdinsdefecte = Hwindow - Hdinsresta;
		homeHdetfoot=Hdetfoot+10;
		homeHdetfoot2m=(homeHdetfoot/2)-10;

		Hdins = 0;
		$('.dins').each(function(){
			if($(this).outerHeight(false) > Hdins){
				Hdins = $(this).outerHeight(false);
			}
		});

		H4dins = Hdins + Hh4;

		//console.log('f:'+Hfooter+', h:'+Hheader+', n:'+HNoMain);
		section.css({'min-height':'calc(100vh - '+HNoMain+'px)'});
		$('.amunt').css({'bottom':Hdetfoot150+'px'});
		optiondiv.css({'margin-top':'-'+Hoptiondiv2+'px'});
		(function($, viewport){
			if( viewport.is('xs') ) {
				$('body').addClass("xs");
				section.addClass("xs");
				footer.addClass("xs");
				dins.addClass("xs");
				$('.option').addClass("xs");

				$('nav,aside').animate({'opacity':1},400,function(){$('nav,aside').css({'display':'block'});});
				if($('section').hasClass('xs') == false){
					$('#home article,#home .option').css({'min-height':'calc(100vh - '+homeHdetfoot+'px)'});
				}else{
					$('#home article,#home .option').css({'min-height':'calc(50vh - '+homeHdetfoot2m+'px)'});
				}

				
				nav.css({'margin-top': '0px', 'min-height': H4dins});
				if(Hsection <= Hwindow){
					$('#inner section').css({'min-height':'calc(100vh - '+Hheadfoot+'px)','padding-bottom': homeHdetfoot+'px'});
					$('#inner #details').css({'padding-bottom':'0px'});
				}else{
					$('#inner section').css({'min-height':Hmainhf+'px','padding-bottom': homeHdetfoot+'px'});
					$('#inner #details').css({'bottom':Hfooter+'px'});
				}
			}else{
				section.removeClass("xs");
				footer.removeClass("xs");
				dins.removeClass("xs");
				$('.option').removeClass("xs");

				$('#home article,#home .option').css({'min-height':'calc(100vh - '+Hfoot10+'px)'});
				$('#inner section').css({'padding-bottom': '0px'});
				nav.css({'margin-top': Hh4+'px'});
				
				if( Hdins <= Hdinsdefecte ){
					$('#inner .dins, nav').css({'min-height':'calc(100vh - '+Hdinsresta+'px)','margin-bottom': '0px'});
				}else{
					$('#inner .dins, nav').css({'min-height':Hdins+'px','margin-bottom': '15px'});
				}
				
			}
		})(jQuery, ResponsiveBootstrapToolkit);
	},

	togglePart: function(){
		idthis = $(this).attr("id");
		if($('body').hasClass('on') == false){
			$(idthis).css({
				'-ms-transform': 'translateX(0vw)',
				'-webkit-transform': 'translateX(0vw)',
				'transform': 'translateX(0vw)'
			})
			.promise()
			.done(function(){
				$('body').addClass('on');
			});
		}else{
			$('nav,aside').css({
				'-ms-transform': '',
				'-webkit-transform': '',
				'transform': ''
			})
			.promise()
			.done(function(){
				$('body').removeClass('on');
			});
		}
	},

	scrollImg: function(){
	    content_height = $(document).height();
	    content_scroll_pos = $(window).scrollTop();
	    window_height = $(window).height();
	    percentage_value = content_scroll_pos * 100 / content_height;
	    percentage_content = ((window_height+content_scroll_pos)*100)/content_height;
		// console.log('content_height:'+content_height+', content_scroll_pos:'+content_scroll_pos+', percentage_value:'+percentage_value+', window_height:'+window_height);
		if (!(isMobile.any())){
			if(content_height > window_height){
			    if(percentage_value >= 55){
			        $('.amunt').fadeIn(500);
			    }else{
			    	$('.amunt').fadeOut(500);
			    }
			}
		}
    },

    scrollTop: function(){
    	body = $("html, body");
		body.animate({scrollTop:0}, '500', 'swing', function(){});
    },

    togglingInfo: function(){
    	nameSelect = $(this).attr('name');
    	if(!($('.isel.active').hasClass(nameSelect))){
	    	$('aside .isel').removeClass('active');
	    	$('aside .isel.'+nameSelect).addClass('active');
    	}
    },

    browserDetect: function(){
	    var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        var trident = ua.indexOf('Trident/');
        var edge = ua.indexOf('Edge/');
        var isIE = null;
        if ((msie > 0)||(trident > 0)||(edge > 0)){
        	isIE = true;
        	if (msie > 0) {/*IE 10 or older*/}
	        else if (trident > 0) {/*IE 11*/}
	        else if (edge > 0) {/*Edge*/}

        } else {
            isIE = false;
        }

        if(isIE==true){$('#proces').hide();}
    },

    loadReady: function(){
    	$('#preloader').hide();
    	$('.wrap').fadeTo('slow', 1);
	}
}

main.initialize();
